module.exports = __webpack_public_path__ + "static/laser-f546ff215d31a463b8a91e157754ee7b.png";